import { toast, ToastOptions } from 'react-toastify';

import { ToastComponent } from 'components/ToastComponent';

type ToastType = 'success' | 'error' | 'info' | 'warning';
type ToastFnType = 'showSuccess' | 'showError' | 'showInfo' | 'showWarning';

type IToastFn = (message: string, title?: string, options?: ToastOptions) => void;
type IToastService = Record<ToastFnType, IToastFn>;

const showToast = (type: ToastType, message: string, title?: string, options?: ToastOptions) => {
  const content = <ToastComponent title={title} message={message} />;
  toast[type](content, options);
};

const ToastService: IToastService = {
  showSuccess(message, title, options) {
    showToast('success', message, title, options);
  },
  showError(message, title, options) {
    showToast('error', message || 'Unknown error', title, options);
  },
  showInfo(message, title, options) {
    showToast('info', message, title, options);
  },
  showWarning(message, title, options) {
    showToast('warning', message, title, options);
  },
};

export default ToastService;
